<template>
  <div v-frag class="text-center">
    <v-bottom-sheet v-model="sheet" v-if="$DEBUG" scrollable>
      <v-card>
        <v-card-text>
          <pre>
        {{ data }}
      </pre
          >
        </v-card-text>
      </v-card>
    </v-bottom-sheet>

    <div v-frag style="display:none">{{ debug }}</div>
  </div>
</template>
<script>
export default {
  name: "DebugModal",
  props: ["data"],
  components: {},
  watch: {
    sheet: {
      handler() {
        if (!this.sheet) {
          this.$store.dispatch("debug", "");
        }
      },
      deep: true
    }
  },
  computed: {
    debug() {
      let that = this;
      if (this.$store.getters.debug == 2) {
        that.sheet = true;
      }
      return this.$store.getters.debug;
    }
  },
  data: () => ({
    sheet: false,
    tiles: [
      { img: "keep.png", title: "Keep" },
      { img: "inbox.png", title: "Inbox" },
      { img: "hangouts.png", title: "Hangouts" },
      { img: "messenger.png", title: "Messenger" },
      { img: "google.png", title: "Google+" }
    ]
  }),
  methods: {}
};
</script>
